module.exports = __webpack_public_path__ + "static/media/coupon04_ja.37eaac5f.png";